/* eslint-disable @next/next/no-img-element, react/forbid-component-props */
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { DEALS_CONFIG } from '../../../../brands/default/config';
import {
  replaceImageServer,
  usePlaceholderImage,
} from '../../../../helpers/image';
import { showVideo } from '../../../../helpers/video';
import ThemeContext from '../../../../providers/ThemeProvider';

const CarouselThumb = ({
  index,
  deal,
  image,
  selected,
  thumbWidth,
  onSelect,
  invert,
}) => {
  const theme = useContext(ThemeContext);
  const hidePlayIcon = index || !deal || !showVideo(deal);

  return (
    <>
      <li className={classNames('thumb', { 'thumb--selected': selected })}>
        <button
          className="thumb__button"
          onClick={() => onSelect(index)}
          type="button"
        >
          {!hidePlayIcon && (
            <FontAwesomeIcon
              icon={faPlayCircle}
              style={{ height: 20, width: 20 }}
            />
          )}
          <img
            alt={image.alt}
            className="thumb__image"
            height={DEALS_CONFIG.DEFAULT_DEAL_IMG_HEIGHT_THUMB}
            onError={usePlaceholderImage}
            src={replaceImageServer({
              dealId: deal.id,
              height: DEALS_CONFIG.DEFAULT_DEAL_IMG_HEIGHT_THUMB,
              image,
              width: DEALS_CONFIG.DEFAULT_DEAL_IMG_WIDTH_THUMB,
            })}
            width={DEALS_CONFIG.DEFAULT_DEAL_IMG_WIDTH_THUMB}
          />
        </button>
      </li>
      <style jsx>{`
        .thumb {
          position: relative;
          display: inline-block;
          cursor: pointer;
          margin: 0 3px;
        }
        .thumb__button {
          padding: 3px;
          border: 3px solid transparent;
          transition: border 0.1s;
          background-color: transparent;
        }
        .thumb--selected .thumb__button,
        .thumb__button:hover,
        .thumb__button:focus {
          border: 3px solid ${invert ? '#ffffff' : theme.colors.primary};
          outline: none;
        }
        .thumb__image {
          width: ${thumbWidth}px;
        }
        :global(.thumb svg) {
          color: ${theme.colors.dealvideoicon};
          filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
          position: absolute;
          top: 9px;
          left: 9px;
        }
        @media (prefers-reduced-motion) {
          .thumb__button {
            transition: none;
          }
        }
      `}</style>
    </>
  );
};

CarouselThumb.propTypes = {
  deal: PropTypes.object,
  image: PropTypes.object,
  index: PropTypes.number,
  invert: PropTypes.bool,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
  thumbWidth: PropTypes.number,
};

CarouselThumb.defaultProps = {
  deal: {},
  image: {},
  index: 0,
  invert: false,
  onSelect: () => false,
  selected: false,
  thumbWidth: 54,
};

export default CarouselThumb;
